import React, {useEffect} from 'react'
import SearchIcon from '../../../styles/images/SearchIcon'
import useCampaignStore from 'store/useCampaignStore'
import {useNavigate} from 'react-router-dom'

/**
 * @desc Search Text Input component
 */
const SearchInput = () => {
  const [searchText, setSearchText] = React.useState('')
  const {searchedText, list, setFilteredList, setSearchedText} = useCampaignStore()
  const navigate = useNavigate()

  //Search Event
  const keyUpEvt = (e) => {
    e.preventDefault()
    if (searchText.length > 0) {
      setSearchedText(searchText) //text value set

      console.log(`%c[search] value::  ${searchText}`, 'background:gray; color:white; padding:2px;')
      //list set(filtering)
      const allList = list.filter(
        (f) =>
          f.content.toLowerCase().indexOf(searchText) > -1 ||
          f.title.toLowerCase().indexOf(searchText) > -1
      )
      console.log(allList)
      setFilteredList(allList)

      navigate('/campaigns')
    } else if (searchText.length === 0) {
      setSearchedText('') //reset
      setFilteredList(list) //list
      navigate('/campaigns')
    }
  }

  useEffect(() => {
    searchedText === '' && setSearchText('')
  }, [searchedText])

  return (
    <div className='max-h-9 mt-3 flex flex-none justify-end items-center border border-neutral-200 bg-slate-50 rounded-lg transition-all my-1'>
      <form onSubmit={keyUpEvt} className='flex'>
        <input
          type='text'
          className=' max-w-md px-3 focus:outline-none placeholder:text-xs font-medium text-neutral-600 text-xs outline-none border-none focus:border-transparent'
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder='Search'
        />
        <button type='submit'>
          <SearchIcon />
        </button>
      </form>
    </div>
  )
}

export default SearchInput
